import { useTranslations } from "../../i18n";
import { Button } from "../Button/Button";
import { Text } from "../Text";
import { useTableContext } from "./context";

export const Selection = () => {
  const { t } = useTranslations();
  const { pagination, selection, items } = useTableContext();

  const hasSelection =
    selection && (selection.selectAll || selection.selectedItems.length > 0);
  const totalItems = pagination?.totalItems || items.length;
  const itemsOnCurrentPage = items.length;

  if (!hasSelection) {
    return null;
  }

  return (
    <div className="nuco-table__selection">
      <Text className="nuco-table__selection-text">
        {selection.selectAll
          ? t("ui.table.selectionSummaryAll", { total: totalItems })
          : t("ui.table.selectionSummary", {
              count: selection.selectedItems.length,
              total: itemsOnCurrentPage,
            })}
      </Text>
      {selection.showSelectAllButton &&
        !selection.selectAll &&
        selection.onSelectAll && (
          <Button size="xs" variant="outline" onClick={selection.onSelectAll}>
            {t("ui.table.selectAllButton", { total: totalItems })}
          </Button>
        )}
    </div>
  );
};
